export const Config = {
  COMPANY_ROOT_URL_DEV: "https://afgstage-scm.truckxi.com",
  COMPANY_ROOT_URL_PROD: "https://afg-scm.truckxi.com",
  
  COMPANY_NAME: "AFG",
  COMPANY_PHONE: "(888) 482-2742",
  COMPANY_SUPPORT_EMAIL: "Info@AsianFoodGrocer.com",
  COMPANY_FB: "https://www.facebook.com/AsianFoodGrocer/",
  COMPANY_IG: "https://www.facebook.com/AsianFoodGrocer/",
  COMPANY_TT: "https://twitter.com/AsianFoodGrocer",
  COMPANY_GG: "",
  COMPANY_YT: "https://www.youtube.com/user/asianfoodgrocer",
  COMPANY_ADDRESS: {
    ADDRESS_LINE_1: "50 W Ohio Ave",
    ADDRESS_LINE_2: "",
    CITY: "Richmond",
    COUNTRY: "USA",
    STATE: "CA",
    ZIP: "97804"
  },
  COMPANY_BUSINESS_HOURS: "11:30am - 11:30pm",
  COMPANY_TERMS:"1. Terms\n\nBy accessing this web site, you are agreeing to be bound by these web site Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this web site are protected by applicable copyright and trade mark law.\n\n\n\n2. Use License\n\n● Permission is granted to temporarily download one copy of the materials(information or software) on Myu Myu's web site for personal, non-commercialtransitory viewing only. This is the grant of a license, not a transfer of title, andunder this license you may not:\n\n○ modify or copy the materials;\n\n○ use the materials for any commercial purpose, or for any public display(commercial or non-commercial);\n\nattempt to decompile or reverse engineer any software contained on MyuMyu's web site;\n\nremove any copyright or other proprietary notations from the materials; or transfer the materials to another person or ''mirror'' the materials on anyother server.\n\nThis license shall automatically terminate if you violate any of theserestrictions and may be terminated by Myu Myu at any time. Upon terminatingyour viewing of these materials or upon the termination of this license, youmust destroy any downloaded materials in your possession whether inelectronic or printed format.\n\n\n\n3. Disclaimer\n\nThe materials on Myu Myu's web site are provided ''as is''. Myu Myu makes nowarranties, expressed or implied, and hereby disclaims and negates all otherwarranties, including without limitation, implied warranties or conditions ofmerchantability, fitness for a particular purpose, or non-infringement ofintellectual property or other violation of rights. Further, Myu Myu does notwarrant or make any representations concerning the accuracy, likely results, orreliability of the use of the materials on its Internet web site or otherwiserelating to such materials or on any sites linked to this site.\n\n\n\n4. Limitations\n\nIn no event shall Myu Myu or its suppliers be liable for any damages (including,without limitation, damages for loss of data or profit, or due to businessinterruption,) arising out of the use or inability to use the materials on Myu Myu'sInternet site, even if Myu Myu or a Myu Myu authorized representative has beennotified orally or in writing of the possibility of such damage. Because somejurisdictions do not allow limitations on implied warranties, or limitations of liabilityfor consequential or incidental damages, these limitations may not apply to you.\n\n\n\n5. Revisions and Errata\n\nThe materials appearing on Myu Myu's web site could include technical,typographical, or photographic errors. Myu Myu does not warrant that any of thematerials on its web site are accurate, complete, or current. Myu Myu may makechanges to the materials contained on its web site at any time without notice. MyuMyu does not, however, make any commitment to update the materials.\n\n\n\n6. Links\n\nMyu Myu has not reviewed all of the sites linked to its Internet web site and is notresponsible for the contents of any such linked site. The inclusion of any link doesnot imply endorsement by Myu Myu of the site. Use of any such linked web site isat the user's own risk.\n\n\n\n7. Site Terms of Use Modifications\n\nMyu Myu may revise these terms of use for its web site at any time without notice.By using this web site you are agreeing to be bound by the then current version ofthese Terms and Conditions of Use.\n\n\n\n8. Governing Law\n\nAny claim relating to Myu Myu's web site shall be governed by the laws of theState of California without regard to its conflict of law provisions.General Terms and Conditions applicable to Use of a Web Site.\n\n\n\n",
  COMPANY_PRIVACY_POLICY:"OUR COMMITMENT TO PRIVACY\n\nYour privacy is important to us. MyuMyu, Inc. we are providing this notice to describe and explain our information collection practices and the choices you can make about the way your information is collected and used.\n\nTHE INFORMATION WE COLLECT AND HOW WE COLLECT IT\n\nIn general, you can visit this mobile app, and use associated MyuMyu technologies, without telling us who you are or revealing any personal information about yourself. There are times, however, when we may gather information from you. Personal information like your name, corporation name, postal address, phone number, and e-mail address is obtained only when voluntarily submitted to become a member of MyuMyu Technical information, like details about your device and IP address, may be collected by virtue of your use of certain other MyuMyu technologies. MyuMyu collects this information in several ways:\n\t * Through the MyuMyu Profile page (see below)\n\t * Through membership registration, surveys and other online forms (some of which may be managed by third parties on behalf of MyuMyu)\n\t * Through the process of maintaining and upgrading our services solutions\n\t * Through automated means such as communications protocols, e-mail communications and cookies\n\t * Through our mobile applications (some of which may be managed by third parties on behalf of MyuMyu)\n\t * Through payment process (such as financial account information used)\n\t * Through your use of social connectors and MyuMyu affiliated social networking areas\n\t * Through your interest in MyuMyu ads placed on third party sites\n\t * Through an ongoing sales process\n\t * Through providing customer support, consultation, live chat, or services solutions information\nTo provide you with timely, high-quality information, we may also ask you to provide us with information regarding your professional interests and experiences with our products or services. Providing us with this information is optional. Personal data or other data collected online may also be combined with information you provide to us through other sources such as membership registration, call centers, or in conjunction with events such as trade shows, training seminars and conferences. Information that you supply will relate to the relationship that MyuMyu has with you or your organization.\n\nYOUR MyuMyu PROFILE\n\nYour MyuMyu profile is one collection point we use to manage your personal information. You can create, access, and update your profile information at any time by visiting our moblie app. Creating a MyuMyu Profile enables you to:\n\t * Specify your preferences related to the communication between MyuMyu and you\n\t * Gain access to restricted site contents\n\t * Access MyuMyu statistical data and analytical reports\n\t * Access your unique business intelligence reports customized by MyuMyu\n\t * View webcasts and other online events\n\t * Subscribe to MyuMyu e-news which is delivered to your in-box and targeted to your needs and interests\n\t * Manage your subscriptions to print and online MyuMyu publications\n\t * Receive e-mail alerts when key content goes live\n\t * Auto-populate form fields with personal information when you make online transactions or complete event registration forms\n\nWEB SERVER LOGS\n\nIn the process of administering this site, we maintain and track usage through Web server logs. Web server logs provide information such as what types of browsers are accessing our site, what pages receive high traffic, what products, services and the times of day that our servers experience significant load. We use this information to improve the content and navigation features of our site. Anonymized or aggregated forms of this data may be used to identify future features and functions to develop for the site and to provide better customer services.\n\nCOOKIES\n\nCertain technologies, called \"cookies,\" can be used to provide tailored information from a website. A cookie is an element of data that a website can send to your browser, which your browser may then store on your system. Some pages on our site use cookies that assist you in navigating and using the site, for example, to help you access secure areas or use a shopping cart. MyuMyu may set these types of cookies without requesting your consent. Other pages on the site may set cookies to collect aggregate usage information that we use to improve how the site works. Cookies may also be used on our site to remember certain choices you make, such as your geographical region, your user name, or other personalization or customization. We use these cookies to improve your user experience so we can better serve you when you return to our site. MyuMyu will consider your use of the Web site as your consent for MyuMyu to set these types of cookies. MyuMyu may work with selected third-party partners who set cookies to serve you MyuMyu-related content, including MyuMyu advertisements, on their sites or elsewhere on the Internet, based on your prior visits to our site. MyuMyu also sets cookies that look at your preferences when you use the website so that MyuMyu may offer you tailored marketing collateral that you may be interested in. You may need to enable use of these kinds of cookies via the mechanism provided by MyuMyu for these cookies to work. You can set your browser to notify you when you receive a cookie, giving you the chance to decide whether to accept it. By using our website, you agree that we can place these types of cookies on your system. For more information, please refer to user information provided with your Web browser. Please note that if you disable cookies, some site functionality may be limited.\n\nWEB BEACONS\n\nSome of our Web pages and HTML-formatted e-mail use Web beacons in conjunction with cookies to compile aggregate statistics about website usage. A Web beacon is an electronic image, called a single-pixel (1x1) or clear GIF. Web beacons can recognize certain types of information on a visitor's computer, such as a visitor's cookie number, time and date of a page view and a description of the page where the Web beacon is placed. You may render some Web beacons unusable by rejecting their associated cookies.\n\nPERSONALIZED URL LINKS AND PERSONALIZED MESSAGE CONTENT\n\nOccasionally, we may create a unique web URL link for certain visitors. If you visit one of these sites, you may find forms that are already filled out with your name, or other types of information you have previously indicated an interest in, based on information you have given us before. We may also personalize the content of newsletters, e-mail offers, invitations, or MyuMyu advertisements served to you on our third party partners' websites, based on topics in which you have previously indicated an interest. We collect information about how you consume this type of personalized information in order to help us provide you with other information that is better tailored to your interests. If you choose to visit one of these personalized Web URL links, you are agreeing to allow MyuMyu to collect information about your visits and also to associate that information with other information about you and your relationship with MyuMyu. If you do not wish your information to be used in this way, do not accept the invitation to visit these sites.\n\nOTHER TECHNOLOGIES\n\nWe may use other technologies to capture specific data, such as the pages you view, your past search preferences, the items you download, the links you click, your access times, and your Internet Protocol (IP) address, domain name, and system configurations and settings, to help us understand how you use MyuMyu-affiliated technologies, serve you relevant content, customize or personalize you experiences on MyuMyu, and to assist you with questions you may have regarding our products and services. If you decided that you want to fine-tune the information that MyuMyu is providing to you, we invite you to update your MyuMyu Profile.\n\nHOW WE USE YOUR INFORMATION\n\nMyuMyu may use your personal information to:\n\t * Further strengthen protections for our members on their business operations on MyuMyu.\n\t * Fulfill membership subscription requests, orders for ecommerce and services made online and to provide you with other information you have requested\n\t * Make the website easier for you to use\n\t * Help us customize content most relevant to your interests\n\t * Notify you about important news concerning MyuMyu\n\t * Notify you of new products and services, product updates, technical support issues, events and special offers we think you may be interested in\n\t * Promote our products and services on our website and third party partners\u2019 websites\n\t * Prevent and detect fraud or other prohibited or illegal activity\n\t * Protect the security and integrity of the website\n\t * We do analyze some of our Web services such as registrations, business intelligence reports, downloads, and e-mail responses at the individual level in order to improve the quality of those offerings and to better tailor our marketing to our customers' needs.\n\nHOW WE SHARE YOUR INFORMATION\n\nWe may share the personal data you provide with other MyuMyu entities and\/or business partners for purposes related to those described above. We will not sell, rent or lease to others your personally identifiable information. MyuMyu reserves the right to disclose any and all pertinent information to law enforcement or other governmental officials as we, in our sole discretion, believe necessary or appropriate.\n\nCHOICE\/OPT-OUT\n\nMyuMyu offers you the choice of receiving different types of communication and information related to our company, products and services. You may subscribe to e-newsletters or other publications; you may also elect to receive marketing communications and other special offers from us via e-mail. If at any time you would like to change your communication preferences, we provide unsubscribe links and an opt-out mechanism for your convenience. You may also access and manage your preferences from your MyuMyu Profile page.\n\nOUR COMMITMENT TO DATA SECURITY\n\nMyuMyu is concerned about the security of your information. To prevent unauthorized access or disclosure, to maintain data accuracy, and to ensure the appropriate use of information, we have put in place reasonable physical, electronic, and managerial procedures to safeguard and secure the information we collect online. We use encryption technology when collecting or transferring sensitive data such as credit card information. Credit card numbers are used only for processing payment and are not used for other purposes.\n\nEXTERNAL LINKS\n\nLinks to third-party websites from this website are provided solely as a convenience to you. If you use these links, you will leave this site. We have not reviewed these third-party sites and do not control them. MyuMyu does not assume responsibility for any of these sites, their content, or their privacy policies. MyuMyu does not endorse or make any representations about them or any information, software or other products or materials found there, or any results that may be obtained from using them. If you decide to access any of the third-party sites linked to this site, you do so at your own risk.\n\nCHANGES TO THIS STATEMENT\n\nIf there are updates to the terms of MyuMyu online Privacy Statement, we will post those changes here and update the revision date in this document so that you will always know what information we collect online, how we use it, and what choices you have. Your continued use of MyuMyu website following the posting of changes to this Privacy Statement means you accept those changes.\n\n\n"
};

// state for address
export const STATES = [
  {
      value: 'AL',
      label: 'ALABAMA'
  },
  // {
  //     value: 'AK',
  //     label: 'ALASKA'
  // },
  {
      value: 'AZ',
      label: 'ARIZONA'
  },
  {
      value: 'AR',
      label: 'ARKANSAS'
  },
  {
      value: 'CA',
      label: 'CALIFORNIA'
  },
  {
      value: 'CO',
      label: 'COLORADO'
  },
  {
      value: 'CT',
      label: 'CONNECTICUT'
  },
  {
      value: 'DE',
      label: 'DELAWARE'
  },
  {
      value: 'DC',
      label: 'District of Columbia'
  },
  {
      value: 'FL',
      label: 'FLORIDA'
  },
  {
      value: 'GA',
      label: 'GEORGIA'
  },
  // {
  //     value: 'HI',
  //     label: 'HAWAII'
  // },
  {
      value: 'ID',
      label: 'IDAHO'
  },
  {
      value: 'IL',
      label: 'ILLINOIS'
  },
  {
      value: 'IN',
      label: 'INDIANA'
  },
  {
      value: 'IA',
      label: 'IOWA'
  },
  {
      value: 'KS',
      label: 'KANSAS'
  },
  {
      value: 'KY',
      label: 'KENTUCKY'
  },
  {
      value: 'LA',
      label: 'LOUISIANA'
  },
  {
      value: 'ME',
      label: 'MAINE'
  },
  {
      value: 'MD',
      label: 'MARYLAND'
  },
  {
      value: 'MA',
      label: 'MASSACHUSETTS'
  },
  {
      value: 'MI',
      label: 'MICHIGAN'
  },
  {
      value: 'MN',
      label: 'MINNESOTA'
  },
  {
      value: 'MS',
      label: 'MISSISSIPPI'
  },
  {
      value: 'MO',
      label: 'MISSOURI'
  },
  {
      value: 'MT',
      label: 'MONTANA'
  },
  {
      value: 'NE',
      label: 'NEBRASKA'
  },
  {
      value: 'NV',
      label: 'NEVADA'
  },
  {
      value: 'NH',
      label: 'NEW HAMPSHIRE'
  },
  {
      value: 'NJ',
      label: 'NEW JERSEY'
  },
  {
      value: 'NM',
      label: 'NEW MEXICO'
  },
  {
      value: 'NY',
      label: 'NEW YORK'
  },
  {
      value: 'NC',
      label: 'NORTH CAROLINA'
  },
  {
      value: 'ND',
      label: 'NORTH DAKOTA'
  },
  {
      value: 'OH',
      label: 'OHIO'
  },
  {
      value: 'OK',
      label: 'OKLAHOMA'
  },
  {
      value: 'OR',
      label: 'OREGON'
  },
  {
      value: 'PA',
      label: 'PENNSYLVANIA'
  },
  {
      value: 'RI',
      label: 'RHODE ISLAND'
  },
  {
      value: 'SC',
      label: 'SOUTH CAROLINA'
  },
  {
      value: 'SD',
      label: 'SOUTH DAKOTA'
  },
  {
      value: 'TN',
      label: 'TENNESSEE'
  },
  {
      value: 'TX',
      label: 'TEXAS'
  },
  {
      value: 'UT',
      label: 'UTAH'
  },
  {
      value: 'VT',
      label: 'VERMONT'
  },
  {
      value: 'VA',
      label: 'VIRGINIA'
  },
  {
      value: 'WA',
      label: 'WASHINGTON'
  },
  {
      value: 'WV',
      label: 'WEST VIRGINIA'
  },
  {
      value: 'WI',
      label: 'WISCONSIN'
  },
  {
      value: 'WY',
      label: 'WYOMING'
  },
]



//////////////////
// WEBPACK FOOTER
// ./config/default.js
// module id = null
// module chunks = 